module.exports = __webpack_public_path__ + "static/media/scheduled_media.c0a19fb9.xlsx";